/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import React from "react";
import SoftTypography from "components/SoftTypography";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";

export default function Footer({ formData }) {
  const { formFieldAppendix1, values, errors, touched } = formData;
  const { releaseDateAppendix1, representativeAppendix1 } = formFieldAppendix1;
  const selectStyle = {
    fontSize: "0.875rem",
    color: "#495057",
    border: "0.0625rem solid #d2d6da",
    background: "#fff",
    padding: "0.5rem 0.75rem",
    width: "100%",
    borderRadius: "0.5rem",
    outline: "none",
  };
  return (
    <Box mt={5}>
      <Grid container spacing={1}>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            label={representativeAppendix1.label}
            name={representativeAppendix1.name}
            value={values.representativeAppendix1}
            error={errors.representativeAppendix1 && touched.representativeAppendix1}
            success={
              values.representativeAppendix1?.toString().length > 0 &&
              !errors.representativeAppendix1
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={releaseDateAppendix1.label}
            name={releaseDateAppendix1.name}
            error={errors.releaseDateAppendix1 && touched.releaseDateAppendix1}
            success={
              values.releaseDateAppendix1?.toString().length > 0 && !errors.releaseDateAppendix1
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}
